import React from 'react';
import clsx from 'clsx';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * ListItem Component
 * @param className {string} Additionnal CSS Classes
 * @param children {React.ReactNode}
 * @param hasIcon {boolean} If Have icon
 */
const List = ({ className, hasIcon, children, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx(hasIcon ? 'icon-list' : 'list', className));
    return (React.createElement("ul", { "data-testid": testId, className: classes, ...others }, children));
};
export default List;
//# sourceMappingURL=List.js.map